import React, { useState, useEffect, useRef } from 'react'
import LayoutStyle from './LayoutStyle'
import DrawerMenu from '../DrawerMenu'
import { Bell, Sparkles } from 'lucide-react'
import { get } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FaSignOutAlt } from 'react-icons/fa'
import { Drawer, notification, Spin } from 'antd'
import api, { customFuncsApi } from '../../api'
import moment from 'moment'
import DeleteTask from '../Modal/DeleteTask'
import { undiruvchiList } from '../../store/slices'
import { BG_COLOR } from '../../constants/colors'

const Layout = ({ children }) => {
	const { getMe, roleAccess } = useSelector((state) => state.main)
	const navigate = useNavigate()
	const deleteRef = useRef()
	const dispatch = useDispatch()
	const { setValue: setUndiruvchiListValue } = undiruvchiList.actions

	const employeeID = get(getMe, 'EmployeeID', '')
	const isFilterByEmployeeID = roleAccess?.U_MenuTaskFilterByCollector === 'Y'

	const [clicked, setClicked] = useState(false)
	const [notFinished, setNotFinished] = useState([])
	const [isLoadingNotFinished, setIsLoadingNotFinished] = useState(false)
	const [isOpenBell, setIsBellOpen] = useState(false)
	const [executors, setExecutors] = useState([])
	const [accountsDataUSD, setAccountsDataUSD] = useState([])
	const [accountsDataUZS, setAccountsDataUZS] = useState([])

	useEffect(() => {
		getAllGetterMoney()
	}, [])

	const getAllGetterMoney = () => {
		api
			.get(
				`$crossjoin(EmployeesInfo, Departments)?$filter=(Departments/Name eq 'Undiruv' or Departments/Name eq 'Undiruvchi1' or Departments/Name eq 'Undiruvchi3' or Departments/Name eq 'Undiruvchi2') and EmployeesInfo/Department eq Departments/Code&$expand=EmployeesInfo($select=EmployeeID,LastName,FirstName),Departments($select=Name,Code)`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=90000',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				dispatch(setUndiruvchiListValue(resData))
				if (isFilterByEmployeeID) {
					const data = resData.filter(
						(v) => v.EmployeesInfo.EmployeeID === get(getMe, 'EmployeeID', ''),
					)
					setExecutors(data)
				} else setExecutors(resData)
			})
			.catch((err) => {
				// errorRef.current?.open(
				// 	get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
	}

	useEffect(() => {
		api
			.get(
				`ChartOfAccounts?$filter=U_User eq ${employeeID}&$select=Code,Name,AcctCurrency,U_User`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => {
				const resData = JSON.parse(res.data).value
				const uzsCash = resData.filter((item) => item.AcctCurrency === 'UZS')

				const usdCash = resData.filter((item) => item.AcctCurrency === 'USD')
				setAccountsDataUSD(usdCash)
				setAccountsDataUZS(uzsCash)
			})
			.catch((err) => {
				// errorRef.current?.open(
				// 	get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
	}, [])

	const getNotFinishedDuner = () => {
		setIsLoadingNotFinished(true)
		const url = `xsSql/getTasks`
		const params = {
			deadLineStartDate: '',
			deadLineEndDate: moment().add(1, 'day').format('YYYY-MM-DD'),
			dunnerId: isFilterByEmployeeID ? get(getMe, 'EmployeeID', '') : '',
			hasTask: 'Y',
			isProved: 'Yes',
			dunnerStatus: 'NotYet',
			$skip: 0,
		}

		customFuncsApi
			.get(url, {
				params,
			})
			.then((res) => {
				const resData = res.data.value
				const now = moment()
				const deadlineFiltered = resData.filter(
					(v) =>
						moment(v.U_DeadLine, 'YYYY-MM-DD HH:mm:ss').isBefore(
							now,
							'minute',
						) ||
						moment(v.U_DeadLine, 'YYYY-MM-DD HH:mm:ss').isSame(now, 'minute'),
				)
				setNotFinished(deadlineFiltered)
				setIsLoadingNotFinished(false)

				deadlineFiltered.forEach((task) => {
					if (
						moment(task.U_DeadLine, 'YYYY-MM-DD HH:mm:ss').isSame(now, 'minute')
					) {
						console.log(now.format('YYYY-MM-DD HH:mm:ss'))
						notification.info({
							message: `Задача с IMEI ${task.IntrSerial} просрочена!`,
							description: `Задача с дедлайном ${task.U_DeadLine} просрочена!`,

							placement: 'topRight',
							duration: 0,
							showProgress: true,
							pauseOnHover: false,
							onClick: () => {
								viewTask(task)
							},
						})
					}
				})
			})
			.catch((err) => {
				setIsLoadingNotFinished(false)
				notification.error({
					message: `${err.respose.data.message}`,
					description: 'Failed to fetch tasks.',
					placement: 'topRight',
				})
			})
	}

	useEffect(() => {
		getNotFinishedDuner()
		const intervalId = setInterval(getNotFinishedDuner, 60 * 1000)

		return () => clearInterval(intervalId)
	}, [])

	const handleClick = () => {
		navigate('/login', { replace: true })
	}

	const handleClose = () => {
		setClicked(false)
	}

	const viewTask = (v) => {
		deleteRef.current?.open(v)
		setClicked(false)
		setIsBellOpen(false)
	}

	return (
		<LayoutStyle
			style={{
				backgroundColor: BG_COLOR,
			}}
		>
			<DrawerMenu />
			<div className="flex flex-col">
				<div
					className="relative flex h-[80px] w-full items-center justify-end gap-4 pr-10 drop-shadow-xl"
					style={{
						backgroundColor: BG_COLOR,
					}}
				>
					<div className="flex items-center gap-5">
						{/* Demo modul (A/R Invoices topshiriq) — menuda emas, faqat shu yerda */}
						<button
							type="button"
							onClick={() => navigate('/demo')}
							title="Demo: A/R Invoices moduli"
							className="flex h-9 items-center gap-2 rounded-full border border-indigo-100 bg-gradient-to-r from-indigo-50 to-violet-50 px-3.5 text-sm font-medium text-indigo-600 transition hover:border-indigo-200 hover:from-indigo-100 hover:to-violet-100"
						>
							<Sparkles size={15} />
							Demo
						</button>
						<div>
							<Bell
								size={20}
								color="#0085FF"
								onClick={() => setIsBellOpen(!isOpenBell)}
							/>
							<Drawer
								title={
									get(getMe, 'FirstName', '') + ' ' + get(getMe, 'LastName', '')
								}
								onClose={() => setIsBellOpen(false)}
								className="w-full"
								open={isOpenBell}
							>
								<Spin size="large" spinning={isLoadingNotFinished}>
									<div className="flex flex-col gap-2">
										{notFinished.map((item) => (
											<div
												className="flex flex-col  bg-gray-200 p-2 rounded-lg"
												onClick={() => viewTask(item)}
											>
												<span className="font-bold">{`Задача с IMEI ${item.IntrSerial} просрочена!`}</span>
												<span className="mt-2">{`Задача с дедлайном ${item.U_DeadLine} просрочена!`}</span>
												<span>{`Приемщик: ${item.DunnerLastName} ${item.DunnerName}`}</span>
											</div>
										))}
									</div>
								</Spin>
							</Drawer>
						</div>
						<div
							className="flex items-center gap-2"
							onClick={() => setClicked(true)}
						>
							<div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0085FF1A] text-[#0085FF]">
								{get(getMe, 'FirstName', '')[0]}
							</div>
							<h1 className="font-inter text-base font-medium">
								{get(getMe, 'FirstName', '') + ' ' + get(getMe, 'LastName', '')}
							</h1>
						</div>
						<Drawer
							title={
								get(getMe, 'FirstName', '') + ' ' + get(getMe, 'LastName', '')
							}
							onClose={handleClose}
							open={clicked}
						>
							<div className="flex flex-col justify-between h-full">
								<div className="flex flex-col gap-2">
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Сум касса</span>
										<span>
											{accountsDataUZS
												?.map((v) => `${v.Code}-${v.Name}`)
												?.join(' , ')}
										</span>
									</div>
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Доллар касса</span>
										<span>
											{accountsDataUSD
												?.map((v) => `${v.Code}-${v.Name}`)
												?.join(' , ')}
										</span>
									</div>

									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Терминал</span>
										<span>{get(getMe, 'U_TerminalAccount', '')}</span>
									</div>

									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Склад</span>
										<span>{get(getMe, 'U_Warehouse', '')}</span>
									</div>
									<div className="flex items-center justify-between text-gray-800">
										<span className="text-gray-500">Должность</span>
										<span>{get(getMe, 'U_JobTitle', '')}</span>
									</div>
								</div>
								<button
									className="mt-4 flex w-full items-center justify-center gap-2 rounded bg-red-500 p-2 text-white"
									onClick={handleClick}
								>
									Выход <FaSignOutAlt />
								</button>
							</div>
						</Drawer>
					</div>
				</div>
				{children}
			</div>
			<DeleteTask
				getRef={(r) => {
					deleteRef.current = r
				}}
				onClose={() => {
					getNotFinishedDuner()
				}}
				executer={executors}
			/>
		</LayoutStyle>
	)
}

export default Layout
